/** AUTO GENERATED FILE, DO NOT CHANGE MANUALLY */
/** SEE: api/ConstClassFactory */
export const DefaultDataKey = {
country: 'country',
currency: 'currency',
invoiceTax: 'invoiceTax',
invoiceTermNumber: 'invoiceTermNumber',
invoiceTermType: 'invoiceTermType',
language: 'language',
}